import { Form, message } from "antd";
import AButton from "core/presentation/components/Button";
import ATable from "core/presentation/components/Tables";
import ATitle from "core/presentation/components/Title";
import locales from "core/presentation/i18n/locales";
import { useEffect, useState } from "react";
import { typography } from "theme/Typography";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "core/presentation/store/hooks";
import Loader from "core/presentation/components/Loader";
import { RootState } from "core/presentation/store";
import { useSelector } from "react-redux";
// import SearchFilterSection from "core/presentation/components/SearchFilterSection";
import { userThunks } from "user/presentation/store/userSlice";
import DeleteConfirmationModal from "core/presentation/components/DeleteCofirmationBox";
import PaginationTable from "core/presentation/components/PaginationTable";

const VehicleOwnerList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [vehicleOwnerList, setVehicleOwnerList] = useState<any>();
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<any>();
  const { userProfile } = useAppSelector((state) => state.user);
  const { vehicleOwner, vehicleOwnerCount, isLoading, error } = useSelector((state: RootState) => state.user);

  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = Number(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [deleteLoading, handleDeleteLoading] = useState(false);

  const haveAction = userProfile?.user?.permissions.includes("vehicle_owner:delete") || userProfile?.user?.permissions.includes("vehicle_owner:update") || userProfile?.user?.permissions.includes("vehicle_owner:detail");

  const columns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Contact No.", dataIndex: "contact", key: "contact" },
    { title: "Owner Type", dataIndex: "vehicleNo", key: "vehicleNo" },
    { title: "Status", dataIndex: "accountStatus", key: "accountStatus" },
    ...(haveAction
      ? [
          {
            title: "Action",
            dataIndex: "action",
            key: "action",
          },
        ]
      : []),
  ];
  if (!vehicleOwnerList) {
    <Loader />;
  }

  // 
  useEffect(() => {
    setSearchParams({ page: String(currentPage) });
  }, [currentPage, setSearchParams]);

  useEffect(() => {
    if (vehicleOwner) {
      setVehicleOwnerList(vehicleOwner);
    }
  }, [vehicleOwner]);

  const getVehicleOwner = (page: number, input?: string) => {
    dispatch(
      userThunks.getAllNewVehicleOwnerThunk({
        page: page,
        input: input ?? "",
        filter: "",
        report: "&vehicleCount=false&countBids=false",
        limit: 10,
      }),
    );
  };

  // const handleOnSearch = (value: string) => {
  //   getVehicleOwner(currentPage, value);
  // };

  useEffect(() => {
    getVehicleOwner(currentPage);
  }, [dispatch]);

  const handleDelete = async (id: any) => {
    try {
      handleDeleteLoading(true);
      await dispatch(userThunks.deleteVechileOwnerThunk(id));
      message.success("Vehicle Owner deleted successfully");
      setDeleteModalVisible(false);
    } catch (error) {
      message.error("Vehicle Owner delete failed");
    } finally {
      handleDeleteLoading(false);
      getVehicleOwner(currentPage);
    }
  };

  // const showDeleteConfirm = (id: any) => {
  //   setSelectedUserId(id);
  //   setDeleteModalVisible(true);
  // };
  // const handleCreateNewVehicleOwner = () => {
  //   navigate("/vehicle-owner/create");
  // };

  const vehicleOwnerListDataSource = [
    vehicleOwnerList?.vehicleOwners?.map((data: any) => ({
      key: data?.vehicleOwner?.vehicleOwnerId,
      name: data?.vehicleOwnerCategory === "COMPANY" ? data?.userId?.company?.companyName : `${data?.userId?.firstName ?? "-"} ${data?.userId?.middleName ? data?.userId?.middleName : ""} ${data?.userId?.lastName ? data?.userId?.lastName : data?.userId?.firstName ? "" : "-"}`,
      contact: data?.userId?.contactNumber || data?.company?.companyContactNumber,
      vehicleNo: data?.userId?.vehicleOwner?.vehicleOwnerCategory,
      accountStatus: data?.userId?.accountStatus,
      action: (
        <>
          {userProfile?.user?.permissions.includes("vehicle_owner:detail") && (
            <AButton
              style={{
                marginTop: "0",
                padding: "5px",
                color: "#F26533",
                fontSize: "14px",
                fontWeight: "600",
              }}
              type="text"
              onClick={() => {
                navigate(`/vehicle-owner/details/${data?.userId?.userId}`);
              }}
            >
              View
            </AButton>
          )}
        </>
      ),
      date: data.updated_at,
    })),
  ];
  return (
    <div>
      {!loading && (
        <>
          <div>
            <ATitle content={"Vehicle Owner Details"} fontSize={14} fontWeight={600} />
          </div>
          {/* <SearchFilterSection onSearch={handleOnSearch} /> */}

          <div style={{ marginTop: "10px" }}>
            <PaginationTable dataSource={vehicleOwnerListDataSource[0]} columns={columns} loading={loading || !vehicleOwnerList || isLoading} tableTitle="Vehicle Owner List" totalData={vehicleOwnerCount} handleChange={getVehicleOwner} currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>
        </>
      )}
      <DeleteConfirmationModal visible={deleteModalVisible} onConfirm={() => handleDelete(selectedUserId)} onCancel={() => setDeleteModalVisible(false)} loading={deleteLoading} />
    </div>
  );
};

export default VehicleOwnerList;
